// extracted by mini-css-extract-plugin
module.exports = {"message":"_8HXCOdb","icon":"_2WH-c04 refresh icon","content":"_2g2scUS","header":"_3tqZE1a"};